import { useEffect, useRef } from 'react';
import { useSnackBar } from './useSnackBar';

/** Toast a request error once, not on every live sync tick. */
export const useErrorToast = (error: Error | null | undefined) => {
  const displayMessage = useSnackBar();
  const lastMessage = useRef<string | null>(null);
  useEffect(() => {
    if (!error) {
      lastMessage.current = null;
      return;
    }
    if (error.message !== lastMessage.current) {
      lastMessage.current = error.message;
      displayMessage(error.message, 'error', 8000);
    }
  }, [error, displayMessage]);
};
